import { API_BASE } from "@/lib/api";

const DAYS = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

export const MEETING_TYPES = [
  { value: "monday", label: "Monday Briefing", day: "Senin" },
  { value: "kamis", label: "Kamisan Meeting", day: "Kamis" },
];
export const TYPE_LABEL = { monday: "Monday Briefing", kamis: "Kamisan Meeting" };

export function fmtMeetingDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return `${DAYS[dt.getDay()]}, ${d} ${MONTHS[m - 1]} ${y}`;
}

export const imageUrl = (id) => (id ? `${API_BASE}/public/meeting-images/${id}` : null);

export const voteUrl = (publicId) => `${window.location.origin}/vote/${publicId}`;

export function getDeviceId() {
  const k = "ke_vote_device";
  let v = localStorage.getItem(k);
  if (!v) {
    v = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(k, v);
  }
  return v;
}
